var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 420.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M74.316 0h363.368c20.398 0 38.963 8.366 52.425 21.816h.075C503.634 35.266 512 53.862 512 74.316v271.533c0 20.398-8.366 38.963-21.816 52.426l-.075.074c-13.462 13.45-32.027 21.816-52.425 21.816H74.316c-20.454 0-39.05-8.366-52.5-21.816l-1.065-1.164C7.926 383.822 0 365.702 0 345.849V74.316c0-20.454 8.366-39.05 21.816-52.5C35.266 8.366 53.862 0 74.316 0zm228.329 278.351V141.814h43.694v136.537h-43.694zM245.63 141.814h46.091l-33.86 136.537h-63.789l-33.86-136.537h46.096l18.565 86.731h1.97l18.787-86.731zM437.684 35.929H74.316c-10.54 0-20.138 4.328-27.098 11.289-6.961 6.96-11.289 16.558-11.289 27.098v271.533c0 10.175 4 19.457 10.49 26.349l.799.75c6.96 6.96 16.558 11.288 27.098 11.288h363.368c10.564 0 20.169-4.316 27.135-11.251 6.936-6.967 11.252-16.571 11.252-27.136V74.316c0-10.54-4.329-20.138-11.289-27.098-6.929-6.973-16.534-11.289-27.098-11.289z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViLanguageIcon);
export default __webpack_public_path__ + "static/media/vi-language-icon.c3fb31adc746a01fb1b955ef1aae7d2e.svg";
export { ForwardRef as ReactComponent };